import * as React from "react";

const NextArrowIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" fill="none">
            <path
                d="M22.7192 6.78125L21.2802 8.22025L28.0632 15.0002H4V17.0002H28.0632L21.2812 23.7812L22.7192 25.2192L31.2192 16.7192L31.9062 16.0002L31.2192 15.2812L22.7192 6.78125Z"
                fill="#00389D"
            />
        </svg>
    );
};

export default React.memo(NextArrowIcon);
